import { createAsyncThunk } from '@reduxjs/toolkit';
import { getLogsDetails } from '@services/requests/logRecords';

export const ThunkGetLogsDetails = createAsyncThunk(
  'logRecords/getLogDetails',
  async id => getLogsDetails(id),
);
export default {};
